import { BaseService } from './BaseService';
import { FarmBenchmark } from '../models/farm-benchmark';

/**
 * `GET /dashboard/benchmark`, called through `BaseService` rather than the generated client for the same
 * reason `WeightMilestoneService` is. Swap to the generated client once it is regenerated deliberately.
 */
export class FarmBenchmarkService extends BaseService {
  url = '/dashboard/benchmark';

  /**
   * `farmId` scopes the response to a farm other than the token's own business unit, for the admin farms
   * overview. Omitted, the API answers for the signed-in business unit.
   */
  getBenchmark = async (farmId?: string): Promise<FarmBenchmark> => {
    const query = this.BuildQueryString({ farmId });
    const result = await this.Fetch(query ? `${this.url}?${query}` : this.url, 'GET');
    return this.FromResult<FarmBenchmark>(result);
  };
}

export default FarmBenchmarkService;
